var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-12"},[_c('domains-counter')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }